import {gatewayInstance} from "../axiosInstance";
import {SERVICE_ENDPOINT} from "../const";
const BASE_PATH = `${SERVICE_ENDPOINT.TRANSPORT}/work-order`;

const statusMessageMap = {
    400: "Invalid request. Please check required fields.",
    404: "Work Order not found.",
    409: "Duplicate Work Order code or title.",
    500: "Server error occurred while processing Work Order.",
};

export const getWorkOrderErrorMessage = (
    error,
    fallback = "Request failed. Please try again.",
) => {
    const status = error?.response?.status;
    if (!status) {
        return fallback;
    }

    return statusMessageMap[status] || fallback;
};
export const workOrderById = async (id) => {
    try {
        const response = await gatewayInstance.get(
            `${BASE_PATH}/${id}`,
        );
        return response.data;
    } catch (e) {
        console.error(e);
    }
};

export const getIssuesByVehicle = async (vehicleId) => {
    try {
        const response = await gatewayInstance.post(
            `${SERVICE_ENDPOINT.TRANSPORT}/issues/search`,
            { vehicleNumber:vehicleId }
        );
        return response.data;
    } catch (e) {
        console.error(e);
        return [];
    }
};

export const addWorkOrder = async (data) => {
    try {
        const response = await gatewayInstance.post(
            `${BASE_PATH}`,
            data
        );
        return response;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const updateWorkOrder = async (data) => {
    try {
        const response = await gatewayInstance.put(
            `${BASE_PATH}`,
            data
        );
        return response;
    } catch (e) {
        console.error(e);
        return null;
    }
};

export const searchWorkOrderData = async (data) => {
    try {
        console.log(`search`, data);
        const response = await gatewayInstance.post(
            `${BASE_PATH}/search`,
            data,
        );
        console.log(`serch res`, response);
        return response.data;

    } catch (e) {
        console.error(e);
    }
};